import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState } from '../../../../store/app.selectors';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { ChannelStatus } from '../../interfaces/IChannel';
import { changeChannelStatus } from '../../store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-manual-status',
  templateUrl: './manual-status.component.html',
  styleUrls: ['./manual-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManualStatusComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);

  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });
  selectedChannel = computed(() => this.chat().selectedChannel);

  options: { text: string; value: ChannelStatus }[] = [
    {
      text: 'CLOSED',
      value: ChannelStatus.CLOSED,
    },
    {
      text: 'RESPONDED',
      value: ChannelStatus.RESPONDED,
    },
    {
      text: 'OPEN',
      value: ChannelStatus.ACTIVE,
    },
  ];

  showOptions = true;

  setStatusValue(value: ChannelStatus): void {
    const selectedChannel = this.selectedChannel();
    if (!selectedChannel) {
      return;
    }
    this.store.dispatch(
      changeChannelStatus({
        channel: selectedChannel,
        newStatus: value,
        oldStatus: selectedChannel.status ?? ChannelStatus.ACTIVE,
      })
    );
  }
}
